import {
    IElementQuestionAnswer,
    IElementQuestionnaire,
    IQuestionAnswerType,
} from '../../../../../incase-domain/elements/base/questionElementBase';
import {ELEMENT} from '../../../../../incase-domain/elements/base/ElementTypes';
import {AnswerTypes} from '../../../../elements/question/question/QuestionAnswer';
import {IQuestionElements} from '../../../../../incase-domain/elements/question';

export function getUpdatedAnswersForDebatableToggle(highlightedElement: IQuestionElements, isDebatable: boolean): IElementQuestionAnswer[] {
    switch (highlightedElement.type) {
        case ELEMENT.YES_NO_QUESTION_V2:
            return highlightedElement.answers.map((answer, index) => {
                if (isDebatable) {
                    return {
                        ...answer,
                        type: AnswerTypes.DEBATABLE,
                    };
                }
                return {
                    ...answer,
                    type: index === 0 ? AnswerTypes.CORRECT : AnswerTypes.INCORRECT,
                };
            });
        default:
            return highlightedElement.answers.map((answer) => ({
                ...answer,
                type: isDebatable ? AnswerTypes.DEBATABLE : AnswerTypes.INCORRECT,
            }));
    }
}

function getYesNoAnswers(
    answers: IElementQuestionAnswer[],
    changedIndex: number,
    nextTypeMapping: Record<string, IQuestionAnswerType>
): IElementQuestionAnswer[] {
    const newAnswers = [...answers].map((answer, i) =>
        i === changedIndex ? {...answer, type: nextTypeMapping[answer.type] as IQuestionAnswerType} : answer
    );

    const changedAnswer = newAnswers[changedIndex];
    const otherIndex = changedIndex === 0 ? 1 : 0;
    const otherAnswer = newAnswers[otherIndex];

    if (
        (changedAnswer.type === AnswerTypes.CORRECT && otherAnswer.type === AnswerTypes.CORRECT) ||
        (changedAnswer.type === AnswerTypes.INCORRECT && otherAnswer.type === AnswerTypes.INCORRECT)
    ) {
        newAnswers[otherIndex] = {
            ...otherAnswer,
            type: changedAnswer.type === AnswerTypes.CORRECT ? AnswerTypes.INCORRECT : AnswerTypes.CORRECT,
        };
    }
    return newAnswers;
}

export function getUpdatedAnswersForTypeChange(
    highlightedElement: IElementQuestionnaire,
    index: number,
    nextTypeMapping: Record<string, IQuestionAnswerType>
): IElementQuestionAnswer[] {
    switch (highlightedElement.type) {
        case ELEMENT.YES_NO_QUESTION_V2:
            return getYesNoAnswers(highlightedElement.answers, index, nextTypeMapping);
        default:
            return [...highlightedElement.answers].map((answer, i) =>
                i === index ? {...answer, type: nextTypeMapping[answer.type] as IQuestionAnswerType} : answer
            );
    }
}
